import Website from "features/website/pages/Website";
import { AdminHostRoute, PublicHostRoute } from "app/navigation/components/HostRoute";
import { authRoutes } from "./auth-routes";
import { dashboardRoutes } from "./dashboard-routes";
import { spaceRoutes } from "./space-routes";

export const routes = [
    ...spaceRoutes.map((route) => ({
        ...route,
        element: <PublicHostRoute>{route.element}</PublicHostRoute>
    })),
    ...authRoutes.map((route) => ({
        ...route,
        element: <AdminHostRoute>{route.element}</AdminHostRoute>
    })),
    ...dashboardRoutes.map((route) => ({
        ...route,
        element: <AdminHostRoute requiresAuth>{route.element}</AdminHostRoute>
    })),
    { path: '/', element: <PublicHostRoute><Website /></PublicHostRoute> },
    { path: '*', element: <div>404 Not Found</div> }, // Reimplement this and have a better 404 page to the end
];


export default routes;
